export default __webpack_public_path__ + "static/media/Major Rune Stone of the Silent Slayer (V).2109839e.jpg";